<template>
  <div class="c-subscribe">
    <div v-if="showMobileConfirmation">
      <MobileConfirmation @confirm="onConfirmMobile"></MobileConfirmation>
    </div>
    <div v-else-if="showQuestions">
      <QuestionForm @save="onQuestionSubmit"></QuestionForm>
    </div>
    <div v-else-if="subscribed">
      <Subscribed></Subscribed>
    </div>
    <div v-else>
      <h1>{{ duration }}</h1>

      <SignUpButton :disabled="buttonDisabled" :state="signUpState" :copy="copy.button" @signup="signup" />
      <div v-if="signUpState === 'error'" class="c-recovery-link">
        <p>{{ error }}</p>
        <a href="#" @click.prevent="resetState">Problemen? Klik hier om opnieuw te proberen</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MobileConfirmation from './MobileConfirmation.vue'
import Subscribed from './Subscribed.vue'
import SignUpButton from '../SignUpButton.vue'
import QuestionForm from '../questionForm/QuestionForm.vue'
import { authentication } from '@dpgradio/creative'

export default {
  name: 'Subscribe',
  components: { SignUpButton, Subscribed, MobileConfirmation, QuestionForm },
  data() {
    return {
      showMobileConfirmation: false,
      showQuestions: false,
      subscribed: false,
      answers: null,
    }
  },
  computed: {
    ...mapState({
      signupMoment: (state) => state.signupMoment,
      shouldConfirmMobile: (state) => state.shouldConfirmMobile,
      signUpState: (state) => state.signUpState,
      error: (state) => state.signUpError,
    }),
    buttonDisabled() {
      return this.signUpState !== 'idle'
    },
    copy() {
      return this.signupMoment.copy?.default
    },
    hasQuestions() {
      return this.signupMoment.additionalQuestions?.length
    },
    duration() {
      const hours = Math.floor(this.signupMoment.duration / 3600)
      const minutes = Math.floor((this.signupMoment.duration % 3600) / 60)
        .toString()
        .padStart(2, '0')
      const seconds = Math.floor(this.signupMoment.duration % 60)
        .toString()
        .padStart(2, '0')
      if (hours > 0) {
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds}`
      }
      return `${minutes}:${seconds}`
    },
  },
  methods: {
    async signup() {
      this.$store.commit('SET_SIGN_UP_STATE', 'loading')

      try {
        await authentication.require()

        if (this.hasQuestions && !this.answers) {
          this.showQuestions = true
          this.$store.commit('SET_SIGN_UP_STATE', 'idle')
          return
        }

        await this.$store.dispatch('initConfirmationRequirement')

        if (this.shouldConfirmMobile) {
          this.showMobileConfirmation = true
          this.$store.commit('SET_SIGN_UP_STATE', 'idle')
          return
        }

        await this.$store.dispatch('signUp', { answers: this.answers })
        this.subscribed = true
      } catch (error) {
        if (!this.error) {
          this.$store.commit('SET_SIGN_UP_STATE', 'error')
          this.$store.commit('SET_SIGN_UP_ERROR', 'Er is iets misgegaan. Probeer het later nog eens.')
        }
      }
    },
    async onConfirmMobile() {
      this.showMobileConfirmation = false
      this.shouldConfirmMobile = false
      await this.signup()
    },
    async onQuestionSubmit(answers) {
      this.showQuestions = false
      this.answers = answers
      await this.signup()
    },
    resetState() {
      this.$store.commit('SET_SIGN_UP_STATE', 'idle')
      this.$store.commit('SET_SIGN_UP_ERROR', null)
      this.showMobileConfirmation = false
      this.showQuestions = false
    },
  },
}
</script>

<style scoped lang="scss">
input {
  display: block;
  width: 100%;
  font-size: 1.25rem;
  padding: 12px;
  border: 0;
}

.c-input-label {
  padding-bottom: 0.5rem;
}

.c-input {
  box-sizing: border-box;
  width: 100%;
  border-radius: 5px;
  border: solid 2px lightgray;
}

.c-recovery-link {
  text-align: center;
  padding: 10px;

  a {
    color: white;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
